
export enum ApplicationTabNameType {
  QUESTIONNAIRE = "Анкета",
  FOUNDERS = "Учредители",
  EIO = "ЕОИ",
  FINANCE = "Финансы",
  DOCUMENTS = "Документы",
  OFFER = "Предложение",
  CHAT = "Чат",
}
